"use client";
import React, { useEffect } from "react";
import { FaChevronUp } from "react-icons/fa6";

export default function StickyHeaderAndScrollTop() {
  useEffect(() => {
    const header = document.querySelector(".header");
    const scrollBtn = document.querySelector(".scroll-area");

    const handleScroll = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;

      if (header) {
        if (scrollY < 350) header.classList.remove("sticky");
        else header.classList.add("sticky");
      }

      if (scrollBtn) {
        if (scrollY > 400) {
          scrollBtn.style.display = "block";
          setTimeout(() => (scrollBtn.style.opacity = "1"), 10);
        } else {
          scrollBtn.style.opacity = "0";
          setTimeout(() => (scrollBtn.style.display = "none"), 200);
        }
      }
    };

    const handleScrollTop = (e) => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    window.addEventListener("scroll", handleScroll);
    if (scrollBtn) scrollBtn.addEventListener("click", handleScrollTop);

    if (scrollBtn) {
      scrollBtn.style.display = "none";
      scrollBtn.style.opacity = "0";
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollBtn) scrollBtn.removeEventListener("click", handleScrollTop);
    };
  }, []);

  return (
    <>
      <div className="scroll-area">
        <div className='down'>
          <FaChevronUp className="icon"/>
        </div>
      </div>
    </>
  );
}
